import { Injectable } from '@angular/core';
import { Cor } from '@tivic-team/manager-ts/dist/fta';
import { ApiController } from 'app/controllers/api-controller.interface';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environmentv3 } from 'src/environments/environmentv3';



@Injectable()
export class CorVeiculoController implements ApiController<Cor> {
    
    constructor() {}
   
    find(filters?: IFilter): Promise<Cor[]> {
        let request = new Quark(
            new HttpGet ({
                url: new Url({
                    id: 'fta/cor',
                    environment: environmentv3,
                    filter: filters,
                }),
            }),
            new HttpResponse(new Array <Cor> ()) 
        );
        return request.call();
    }

    get(id: number): Promise <Cor> {
        let request = new Quark(
            new HttpGet({
                url: new Url ({
                    id: 'fta/cor/:cdCor',
                    environment: environmentv3,
                    pathParams: new JSONData({ 
                        cdCor: id
                    }),
                }),
            }),
            new HttpResponse(new Cor())
        );
        
        return request.call();
    }

    create(entity: Cor): Promise <Cor> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'fta/cor',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Cor()
            )
        );
        return request.call();
    }

    update(entity: Cor): Promise<Cor> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'fta/cor/:cdCor',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdCor: entity.cdCor
                    }),
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new Cor()
            )
        );
        return request.call();
    }
}